import React, { useState } from "react";
import axios from "axios";
import { Upload, ArrowLeft, ImagePlus } from "lucide-react";
import { useNavigate } from "react-router-dom";
import AdminLayout from "../../Shared/Navbar/Navbar";
import { baseurl } from "../../Api/Baseurl";

const API_URL = `${baseurl}/api`;

const UploadCarouselImage = () => {
  const [file, setFile] = useState(null);
  const [preview, setPreview] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const onSelect = (e) => {
    const f = e.target.files?.[0];
    if (!f) return;
    setFile(f);
    setPreview(URL.createObjectURL(f));
  };

  const uploadImage = async () => {
    if (!file) return alert("Select image");
    setLoading(true);
    try {
      const fd = new FormData();
      fd.append("image", file);
      await axios.post(`${API_URL}/carousel-images/upload`, fd);
      navigate("/carousel-images");
    } catch (err) {
      console.error("Error uploading image:", err);
      alert("Failed to upload image");
    } finally {
      setLoading(false);
    }
  };

  return (
    <AdminLayout>
      <div className="uci-page">
        <button onClick={() => navigate(-1)} className="uci-back-btn">
          <ArrowLeft size={16} /> Back
        </button>

        <div className="uci-card">
          <div className="uci-card-header">
            <ImagePlus size={22} className="uci-header-icon" />
            <div>
              <h2 className="uci-title">Upload Carousel Image</h2>
              <p className="uci-subtitle">This image will appear at the end of the carousel order.</p>
            </div>
          </div>

          <label htmlFor="upload" className={`uci-dropzone ${preview ? "has-preview" : ""}`}>
            <input type="file" hidden id="upload" onChange={onSelect} accept="image/*" />
            {preview ? (
              <img src={preview} alt="Preview" className="uci-preview-img" />
            ) : (
              <div className="uci-dropzone-content">
                <div className="uci-upload-icon-wrap">
                  <Upload size={28} className="uci-upload-icon" />
                </div>
                <p className="uci-dropzone-title">Click to select an image</p>
                <p className="uci-dropzone-sub">or drag and drop</p>
                <p className="uci-dropzone-hint">PNG, JPG or GIF, up to 10MB</p>
              </div>
            )}
          </label>

          {preview && (
            <label htmlFor="upload" className="uci-change-link">
              Choose a different image
            </label>
          )}

          <button onClick={uploadImage} disabled={loading || !file} className="uci-submit-btn">
            {loading ? "Uploading…" : "Upload Image"}
          </button>
        </div>
      </div>

      <style>{`
        .uci-page { padding: 32px; background: #f4f5f7; min-height: 100vh; box-sizing: border-box; }

        .uci-back-btn { display: inline-flex; align-items: center; gap: 8px; margin-bottom: 24px; padding: 8px 14px; border-radius: 8px; border: 1px solid #d1d5db; background: #ffffff; color: #4b5563; font-size: 14px; font-weight: 500; cursor: pointer; transition: all 0.15s ease; }
        .uci-back-btn:hover { background: #f3f4f6; color: #111827; }

        .uci-card { max-width: 560px; margin: 0 auto; background: #ffffff; padding: 28px; border-radius: 16px; box-shadow: 0 1px 3px rgba(0,0,0,0.06); border: 1px solid #e5e7eb; }

        .uci-card-header { display: flex; gap: 12px; align-items: flex-start; margin-bottom: 22px; }
        .uci-header-icon { color: #2563eb; flex-shrink: 0; margin-top: 2px; }
        .uci-title { font-size: 19px; font-weight: 700; color: #111827; margin: 0; }
        .uci-subtitle { font-size: 13px; color: #6b7280; margin: 4px 0 0; }

        .uci-dropzone { display: block; border: 2px dashed #d1d5db; border-radius: 14px; background: #f9fafb; cursor: pointer; overflow: hidden; transition: all 0.15s ease; }
        .uci-dropzone:hover { border-color: #2563eb; background: #eff6ff; }
        .uci-dropzone.has-preview { border-style: solid; padding: 0; }

        .uci-dropzone-content { text-align: center; padding: 48px 20px; }
        .uci-upload-icon-wrap { width: 56px; height: 56px; border-radius: 50%; background: #e0e7ff; display: flex; align-items: center; justify-content: center; margin: 0 auto 14px; }
        .uci-upload-icon { color: #4f46e5; }
        .uci-dropzone-title { font-size: 15px; font-weight: 600; color: #1f2937; margin: 0; }
        .uci-dropzone-sub { font-size: 13px; color: #6b7280; margin: 4px 0 0; }
        .uci-dropzone-hint { font-size: 12px; color: #9ca3af; margin: 10px 0 0; }

        .uci-preview-img { width: 100%; height: 260px; object-fit: cover; display: block; }

        .uci-change-link { display: inline-block; margin-top: 10px; font-size: 13px; color: #2563eb; font-weight: 500; cursor: pointer; }
        .uci-change-link:hover { text-decoration: underline; }

        .uci-submit-btn { width: 100%; margin-top: 22px; padding: 13px; border-radius: 10px; border: none; font-size: 15px; font-weight: 700; background: #2563eb; color: #ffffff; cursor: pointer; box-shadow: 0 1px 2px rgba(0,0,0,0.08); transition: all 0.15s ease; }
        .uci-submit-btn:hover:not(:disabled) { background: #1d4ed8; }
        .uci-submit-btn:disabled { opacity: 0.55; cursor: not-allowed; }
      `}</style>
    </AdminLayout>
  );
};

export default UploadCarouselImage;